import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RoleAccessLayer from "../components/RoleAccessLayer";

const RoleAccessPage = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title="Role Access" />

        {/* RoleAccessLayer */}
        <RoleAccessLayer />

    </>
  );
};

export default RoleAccessPage; 
